// sgi/apps/frontend/ui-enrollment/src/main.ts
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { initLocale } from './i18n'
import './styles/global.scss'

initLocale() // ← Cargar idioma guardado antes de montar

const app = createApp(App)
app.use(router)
app.mount('#app')